export default [
  { icon: 'mdi-information', title: 'Info Kelas', event: 'onDetail', akses: true },
  // { icon: 'mdi-link', title: 'Tautan LMS', event: 'onLms', akses: true },
  { icon: 'mdi-pencil', title: 'Edit Kelas', event: 'onEdit', akses: 'lpd-kelas.update' },
  { icon: 'mdi-delete', title: 'Hapus', event: 'onDeleteKelas', akses: true },
];
